import { useAuth } from 'lib/auth';
import { axios } from 'lib/axios';
import { useNotificationStore } from 'stores/notifications';
import { useMutation } from 'react-query';

export const storeFCMToken = ({ data }) => {
  return axios.patch(`/user/fcmToken`, data);
};

export const useStoreFCMToken = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();
  const { refetchUser } = useAuth();
  return useMutation({
    onSuccess: () => {
      addNotification({
        type: 'success',
        title: 'Subscribed to notifications successfully',
      });
      refetchUser();
    },
    ...config,
    mutationFn: storeFCMToken,
  });
};
